import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {NGX_MAT_DATE_FORMATS, NgxMatDatetimepicker} from '@angular-material-components/datetime-picker';
import {CustomDateFormat} from './date-time-format';
import {distinctUntilChanged, pairwise} from 'rxjs/operators';
import {SimpleChangeValue} from '../../../shared/model/simpeChangeValue-model';
import {Moment} from 'moment-timezone';
import {MomentAdapter, MomentUtils} from '../../../shared/utils/moment.utils';
import {FormUtils} from '../../../shared/utils/form.utils';

@Component({
    selector: 'app-datetime-picker',
    templateUrl: './date-time-picker.component.html',
})
export class DateTimePickerComponent implements OnInit, OnChanges, OnDestroy{
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() maximumDate: Moment;
    @Input() minimumDate: Moment;
    @Input() hideTime: boolean;
    @Output() _onDateChange= new EventEmitter<SimpleChangeValue<Moment>>();

    /** Subject that emits when the component has been destroyed. */
    private onDestroy = new Subject<void>();

    @ViewChild('picker') dateTimePicker: NgxMatDatetimepicker<Moment>;
    displayPreviousAndActiveDateForDebug = false;
    previousAndActiveDate: string;
    previousValue: Moment;

    constructor(@Inject(NGX_MAT_DATE_FORMATS) public customDateFormat: CustomDateFormat) { }


    ngOnInit(): void {
        this.elementControl
            .valueChanges
            .pipe(distinctUntilChanged(), pairwise())
            .subscribe(([prev, active]) => {
                this.previousAndActiveDate = ((prev ? MomentAdapter.of(prev).format() : 'null') + ' --> ' +
                    MomentAdapter.of(active).format());
                /* if (this.dateTimePicker) {
                    if (this.dateTimePicker._selected && active) {
                        if (MomentUtils.difference(this.dateTimePicker._selected, active) !== 0) {
                            // HACK : Obliger de forcer la valeur du formulaire dans le component
                            // car le changement de l'heure dans une même journée (ex: ajout de minutes)
                            // n'est pas répercuté dans la popup de sélection
                            // (l'heure affichée dans l'input n'est pas la même que dans la popup de sélection)
                            this.dateTimePicker._selected = active;
                        }
                    }
                } */ // TODO UX-2023
            });
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.complete();
    }


    ngOnChanges(changes: SimpleChanges): void {
        for (const propName in changes) {
            if (!changes.hasOwnProperty(propName)) {
                continue;
            }
            const change = changes[propName];
            if (propName === 'hideTime') {
                this.customDateFormat.onlyDate = change.currentValue;
                const value = this.elementControl?.value;
                if (value) {
                    // Reset the same value to enforce the change of date format on display
                    FormUtils.setValueWithoutEmitEvent(this.elementControl, value);
                }
            }
        }
    }

    get elementControl() {
        return this.parentFormGroup.get(this.parentFormControlName);
    }

    onOpenPicker() {
        this.previousValue = MomentAdapter.of(this.elementControl.value).get();
    }

    blurred(event) {
        // console.log(['on blur', event]);
        this.onClosePicker();
    }

    focussed() {
        this.onOpenPicker();
    }

    onClosePicker() {
        /*
            HACK : Obliger de forcer le changement de date à la fermeture du picker
            car la date précédente n'est pas correcte dans le valueChange de la méthode ngOnInit()
            (= elle est identique à la date actuelle) lorsque l'utilisateur change l'heure dans l'input et puis
            directement l'heure dans le picker (sans changer la date)
         */
        const prev = this.previousValue;
        const active = this.elementControl.value;
        console.log(active);
        this._onDateChange.next({
            previousValue : prev,
            currentValue : active,
        });
    }

}
